import { embeddedConfigManager } from '../api/embedded/EmbeddedConfigManager'
import { IS_INTEGRATED_VERSION } from '../config/ConfigManager'
import { getCxmlDetails } from './cxmlDetailsUtil'

enum ServiceName {
  AESV3 = 'AESV3',
  MYPLACEV3 = 'MyPlaceV3',
  AES_SERVER_V3 = 'aesServerV3',
  CXML = 'cXML',
}

export const getServiceName = (): ServiceName => {
  if (IS_INTEGRATED_VERSION) {
    return embeddedConfigManager.isAesServer
      ? ServiceName.AES_SERVER_V3
      : ServiceName.AESV3
  }
  if (getCxmlDetails().cxmlData) {
    return ServiceName.CXML
  }

  return ServiceName.MYPLACEV3
}
